import { handleError, api, handleResponse } from "./apiServices";
export const loginApi = data =>
  api()
    .post("/api/merchant/auth/login", data)
    .then(handleResponse)
    .catch(handleError);
export const logoutApi = data =>
  api()
    .post("/api/merchant/auth/logout", data)
    .then(handleResponse)
    .catch(handleError);

export const merchantCheckApi = token =>
  api(token)
    .get("/api/merchant/auth/check")
    .then(handleResponse)
    .catch(handleError);
export const resetPasswordApi = data =>
  api()
    .post("/api/merchant/auth/reset-password", data)
    .then(handleResponse)
    .catch(handleError);

export const forgotPassword = data =>
  api()
    .post("/api/merchant/auth/forget-password", data)
    .then(handleResponse)
    .catch(handleError);

export const verifyOtp = data =>
  api()
    .post("/api/merchant/auth/verify-otp", data)
    .then(handleResponse)
    .catch(handleError);

export const resendOTP = data =>
  api()
    .post("/api/merchant/auth/resend-otp", data)
    .then(handleResponse)
    .catch(handleError);
export const updateUserStatus = (token, id, data) =>
  api(token)
    .patch(`/api/merchant/auth/updateStatus/${id}`, data)
    .then(handleResponse)
    .catch(handleError);
